<template>
  <div class="app-container pull-auto">
    <el-form :inline="true" class="demo-form-inline">
      <el-row class="rowStyle borderBottomStyle">
        <el-col :span="24">
          <el-form-item label="企业信息">
            <el-input placeholder="请输入关键字" v-model="form.condition" clearable></el-input>
          </el-form-item>

          <el-form-item label="申请时间" class="searchdata">
            <el-date-picker v-model="form.time" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
              style="width:160px;">
            </el-date-picker>
          </el-form-item>
          <el-button @click.native="searchList" size="medium" icon="el-icon-search" type="primary">搜索</el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-tabs v-model="activeName" @tab-click="handleClick" class="tabfloat">
      <el-tab-pane label="未开票" name="first">
      </el-tab-pane>
      <el-tab-pane label="未寄出" name="second">
      </el-tab-pane>
      <el-tab-pane label="已寄出" name="third">
      </el-tab-pane>
    </el-tabs>

    <el-row class="rowStyle">
      <el-col :span="24">
        <avue-crud :data="tableData" :option="plateformTicketTable" :page="page" @size-change="sizeChange"
          @current-change="currentChange" @search-reset="searchReset" class="avue-table-self" @row-click="invoiceRow">
          <template slot-scope="scope" slot="id">
            <el-radio class="radio" v-model="resInvRow.id" :label="scope.row.id"></el-radio>
          </template>

          <template slot-scope="scope" slot="menuLeft" class="top-btn">
            <el-button @click="checkDetails" :disabled="checkInvListDetail" size="mini" icon="el-icon-view" type="primary">查看详情</el-button>
            <el-button @click="editInvoice" :disabled="checkInvListDetail" size="mini" icon="el-icon-edit-outline"
              type="primary" v-if="activeName=='first'">开具发票</el-button>
            <el-button @click="sendInvoice" data-type="3" :disabled="checkInvListDetail" size="mini" icon="el-icon-message" type="primary"
              v-if="activeName=='second'">寄出发票</el-button>
          </template>
        </avue-crud>
      </el-col>
    </el-row>

    <el-dialog title="申请开票详情" :visible.sync="invoiceDetailDlg" width="70%"  @close="invoicedlgClose" class="invoicedlg">
      <el-row>
        <el-col :span="6" :offset="4">
          <span class="spantitle">发票抬头：</span>
          <span>{{invoiceInfos.companyInvoiceInfo.commpanyName}}</span>
        </el-col>
        <el-col :span="12">
          <span class="spantitle">收件人姓名：</span>
          <span>{{invoiceInfos.addressInfo.contacts}}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" :offset="4">
          <span class="spantitle">开具类型：</span>
          <span>企业</span>
        </el-col>
        <el-col :span="12">
          <span class="spantitle">收件人电话：</span>
          <span>{{invoiceInfos.addressInfo.phone}}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" :offset="4">
          <span class="spantitle">发票类型：</span>
          <span>{{invoiceInfos.invoiceType==2?'增值税专用发票':'增值税普通发票'}}</span>
        </el-col>
        <el-col :span="12">
          <span class="spantitle">收件人地址：</span>
          <span>
            {{invoiceInfos.addressInfo.provinceName}}
            {{invoiceInfos.addressInfo.cityName}}
            {{invoiceInfos.addressInfo.areaName}}
            {{invoiceInfos.addressInfo.addressee}}
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" :offset="4">
          <span class="spantitle">税务登证记号：</span>
          <span>{{invoiceInfos.companyInvoiceInfo.taxNum}}</span>
        </el-col>
        <el-col :span="12">
          <span class="spantitle">邮编：</span>
          {{invoiceInfos.addressInfo.zipCode}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" :offset="4">
          <span class="spantitle">发票性质：</span>
          <span>纸质</span>
        </el-col>

        <el-col :span="12">
          <span class="spantitle">备注：</span>
          <span >{{invoiceInfos.remarks}}</span>
        </el-col>
      </el-row>

      <div v-if="invoiceInfos.invoiceType==2">
        <el-row>
          <el-col :span="6" :offset="4">
            <span class="spantitle">开户银行名称：</span>
            <span>{{invoiceInfos.companyInvoiceInfo.openingBank}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" :offset="4">
            <span class="spantitle">基本开户账号：</span>
            <span>{{invoiceInfos.companyInvoiceInfo.bankAccount}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" :offset="4">
            <span class="spantitle">注册场所地址：</span>
            <span>{{invoiceInfos.companyInvoiceInfo.address}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" :offset="4">
            <span class="spantitle">注册固定电话：</span>
            <span>{{invoiceInfos.companyInvoiceInfo.telephone}}</span>
          </el-col>
        </el-row>
      </div>

      <span>项目数量:{{projectIds.length}}</span>
      <avue-crud :data="projectDetail" :option="projectDetailOption">
      </avue-crud>
    </el-dialog>

    <el-dialog title="开具发票" :visible.sync="sendInvoiceDlg" width="30%">
      <div style="width: 100%;">
        <div v-for="(item,index) in invoiceNums" class="invoicenum expressinfo" :key="index">
          <div class="invoicenum">
            <div>发票号码：</div>
            <el-input placeholder="请输入8位发票号码" type="number" maxlength="8"
            v-model="invoiceNums[index].invoiceNum" style="flex: 1;" @mousewheel.native.prevent></el-input>
          </div>
          <div class="addimg" @click="(invoiceNums.length-1==index)?addMore():plusThis(index)">
            <img :src='invoiceNums.length-1==index?images[1].src:images[0].src' style="width: 20px;height: 20px;">
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sendInvoice" data-type="1">寄出发票</el-button>
        <el-button @click="sendInvoice" data-type="2">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="寄出发票" :visible.sync="expressInfoDlg" width="30%">
      <div class="invoicenum expressinfo">
        <div>快递公司：</div>
        <el-input placeholder="请输入快递公司名称" type="text" v-model="expressName" style="flex: 1;"></el-input>
      </div>
      <div class="invoicenum expressinfo">
        <div>快递单号：</div>
        <el-input placeholder="请输入快递单号"  v-model="expressNumber" style="flex: 1;" @mousewheel.native.prevent></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sendExpress">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {
    plateformTicketTable,
    projectDetailOption
  } from '@/const/asset/base/manufacturerinfo'
  import {
    getProjectInfo
  } from "@/api/admin/taskManagement";
  import {
    projectInvoice,
    updateInvoiceNum,
    updateInvoiceExpress
  } from '@/api/admin/invoiceManagement'
  import {
    objKeySort
  } from '@/util/ajaxsign'
  export default {
    name: 'plateformInvoice',
    data() {
      return {
        images:[
          {src:require('../../../../public/img/plus.png')},
          {src:require('../../../../public/img/add.png')},
          ],
        activeName: 'first',
        tableData: [],
        listQuery: {
          current: 1,
          size: 10,
          total: 0,
        },
        page: {
          pageSizes: [10, 20, 50, 100],
          currentPage: 1,
          total: 0,
          pageSize: 10
        },
        form: {
          time: '',
          state: '',
          condition: '',
          invoiceState: ''
        },
        mdata: {}, //搜索条件
        resInvRow:{},//已选的行数据
        checkInvListDetail: true,
        radio: '',
        checkDetail: true, //按钮禁用
        tableLoading: false,
        invoiceDetailDlg: false, //发票详情 弹窗
        projectDetail: [], //发票 内项目数据
        sendInvoiceDlg: false, // 开具发票 弹窗
        expressInfoDlg: false, //寄出快递 弹窗
        invoiceNums: [{
          invoiceNum: ''
        }], //发票号码数组
        invoiceInfos: {
          companyInvoiceInfo:{},
          addressInfo:{}
        }, //发票内容信息详情
        projectIds: [], //发票包含项目 id
        expressName: '', //快递名称
        expressNumber: '', //快递单号
        plateformTicketTable: plateformTicketTable,
        projectDetailOption: projectDetailOption,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    created() {
      this.mdata.state=0;
      this.getList();
    },
    methods: {

      getList() {
        let that = this
        that.tableLoading = true;
        that.radio = undefined;
        that.checkInvListDetail=true;
        that.mdata.startDate='';
        that.mdata.stopDate='';
        that.mdata.companyName='';

        that.mdata.pageNum = that.listQuery.current;
        that.mdata.companyName = that.form.condition;
        // 0未开票，1未寄出，2已寄出
        that.mdata.pageSize = that.listQuery.size;

        if (that.form.time) {
          that.mdata.startDate = that.form.time[0];
          that.mdata.stopDate = that.form.time[1];
        }
        //删除 没有数据的 参数
        for(let key in that.mdata){
          if(that.mdata[key]===''){
            delete that.mdata[key]
          }
        }
        projectInvoice(objKeySort(that.mdata)).then(response => {
          if (response.data.code == 200) {
            that.tableData = response.data.data.rows;
            that.tableData.forEach(item => {
              item.check = false
            })
            that.page.total = response.data.data.total
          }
          that.tableLoading = false
        })
      },
      sizeChange(val) {
        this.listQuery.size = val;
        this.page.pageSize = val;
        this.listQuery.current = 1;
        this.mdata.state=0;
        this.getList()
      },
      currentChange(val) {
        this.listQuery.current = val;
        this.page.currentPage = val;
        this.mdata.state=0;
        this.getList()
      },
      //搜索
      searchList(){
        let that = this
        if (that.activeName == 'second') {
          that.mdata.state = 1;
          that.getList()
        } else if (that.activeName == 'third') {
          that.mdata.state = 2;
          that.getList()
        }else{
          that.mdata.state = 0;
          that.getList()
        }
      },
      //选择 数据
      invoiceRow(row){
        let that = this
        that.resInvRow = row;
        if (row) {
          that.checkInvListDetail = false
        } else {
          that.checkInvListDetail = true
        }
      },

      //清空搜索条件
      searchReset() {
        this.form = {};
        this.listQuery.current = 1;
        this.listQuery.size = 10;
        this.getList();
      },

      ticketDetail() {
        // let that = this
        // that.getProjectsInTicket();
        // that.projectInTicket=true;
      },
      //查看 发票信息
      checkDetails() {
        let that = this
        that.invoiceDetailDlg = true;
        that.projectDetail=[];
        //设置 页面信息
        that.invoiceInfos = JSON.parse(JSON.stringify(that.resInvRow));
        that.invoiceInfos.companyInvoiceInfo = JSON.parse(that.resInvRow.companyInvoiceInfo)
        that.invoiceInfos.addressInfo = JSON.parse(that.resInvRow.addressInfo)
        that.projectIds = [];
        if (that.invoiceInfos.projectIds) {
          that.projectIds = that.invoiceInfos.projectIds.split(',');
          that.resInvRow={};
          that.projectIds.forEach(item => {
            new Promise(() => {
              let that = this
              let detail = {
                projectId: '',
                projectName: '',
                userName: '',
                projectType: '',
                priceSum: '',
                startTime: '',
                duration: '',
                workTypeTable: '',
                workTypes: ''
              }
              getProjectInfo(objKeySort({
                projectId: item
              })).then(response => {
                if (response.data.code == 200) {
                  console.log('执行数据整合');
                  // 项目单号
                  detail.projectId = response.data.data.projectId;
                  // 项目名称
                  detail.projectName = response.data.data.projectName;
                  // 发布人
                  detail.userName = response.data.data.userName;
                  // 项目类型
                  detail.projectType = response.data.data.projectType;
                  // 费用总计
                  detail.priceSum = response.data.data.priceSum ? response.data.data.priceSum : (response.data
                    .data.price ?
                    response.data.data.price : 0);
                  // 开工时间
                  detail.startTime = response.data.data.startTime;
                  // 工作时长
                  detail.duration = response.data.data.duration;
                  // 需求师傅
                  detail.workTypeTable = JSON.parse(response.data.data.workTypeTable);
                  detail.workTypes = JSON.parse(response.data.data.workTypes);
                  that.projectDetail.push(detail);
                }
              });
            })

          })

        }

      },
      //关闭 详情弹窗
      invoicedlgClose(){
        let that = this
        that.checkInvListDetail=true;
        that.resInvRow={};
      },
      // 开发票
      editInvoice() {
        let that = this
        that.sendInvoiceDlg = true;
        that.invoiceNums = [{
          invoiceNums: ''
        }];
      },
      //寄出发票
      sendInvoice(e) {
        let that = this
        let _invoiceNum = ''
        let _type=e.currentTarget.dataset.type
        let data={}
        if (_type != 3) {
          for (var i = that.invoiceNums.length-1; i >=0 ; i--) {
            if(that.invoiceNums[i].invoiceNum){
              if(that.invoiceNums[i].invoiceNum.length!=8){
                that.$message({
                  message: '发票号位数不正确,请检查',
                  type: 'warning'
                })
                return
              }
            }else{
              that.$message({
                message: '请输入发票号',
                type: 'warning'
              })
              return
            }
             _invoiceNum += that.invoiceNums[i].invoiceNum + ','
          }
          data.id=that.resInvRow.id;
          data.invoiceNum= _invoiceNum.slice(0, _invoiceNum.length-1);
          that.updateInvoiceNum(data,_type);
        }else{
          that.expressName='';
          that.expressNumber='';
          that.expressInfoDlg = true;
        }
      },
      // 提交 发票号
      updateInvoiceNum(data,type) {
        let that = this
        updateInvoiceNum(objKeySort(data)).then(response => {
          if (response.data.code == 200) {
            that.$message({
              message: '提交成功',
              type: 'success'
            })
            if(type!=1){
              that.mdata.state=1;
            }else{
              that.mdata.state=0;
            }

            that.getList();
            if(type==2){
              that.sendInvoiceDlg=false;
            }else{
              that.expressName='';
              that.expressNumber='';
              that.expressInfoDlg = true;
            }
          }
        })
      },
      // 提交快递
      sendExpress() {
        let that = this
        if(!that.expressName){
          that.$message({
            message: '请输入快递公司名称',
            type: 'warning'
          })
          return
        }
        if(!that.expressNumber){
          that.$message({
            message: '请输入快递单号',
            type: 'warning'
          })
          return
        }
        let data = {
          expressName: that.expressName,
          expressNum: that.expressNumber,
          id: that.resInvRow.id
        }
        updateInvoiceExpress(objKeySort(data)).then(response => {
          if (response.data.code == 200) {
            that.$message({
              message: '提交成功',
              type: 'success'
            })
            that.expressInfoDlg = false;
            that.sendInvoiceDlg = false;
            if(that.activeName=='second'){
              that.mdata.state=1;
            }else{
              that.mdata.state=0;
            }

            that.expressName='';
            that.expressNumber='';
            that.getList();
          }
        })
      },
      // 增加 发票号
      addMore() {
        let that = this
        that.invoiceNums.push({
          invoiceNum: ''
        })
      },
      // 减少 发票号
      plusThis(e) {
        let that = this
        that.invoiceNums.slice().reverse().forEach((item, index, object) => {
          if(e==index){
            that.invoiceNums.splice(object.length - 1 - index, 1);
          }
        })
      },

      //查询状态
      handleClick(tab) {
        let that = this
        that.resInvRow={};
        that.activeName = tab.name;
        that.checkInvListDetail=true;
        if (tab.name == 'first') {
          that.mdata.state = 0;
          that.getList()
        } else if (tab.name == 'second') {
          that.mdata.state = 1;
          that.getList()
        } else if (tab.name == 'third') {
          that.mdata.state = 2;
          that.getList()
        }
      },

      //阻止鼠标滚动
      stopScrollFun(evt) {
        evt = evt || window.event;
          if(evt.preventDefault) {
            evt.preventDefault();
            evt.stopPropagation();
          } else {
            evt.cancelBubble=true;
            evt.returnValue = false;
        }
        return false;
      }
    }


  }
</script>

<style scoped="scoped">
  .invoicenum {
    display: flex;
    align-items: center;
    flex: 1;
  }

  .addimg {
    width: 20px;
    height: 20px;
    margin-left: 20px;
    cursor: pointer;
  }

  .addimg img {
    width: 100%;
    height: 100%;
  }

  .expressinfo {
    margin-top: 15px;
    flex: 1;
  }
  .invoicedlg /deep/ .avue-crud__menu{
    display: none;

  }
  .spantitle{
    min-width: 200px;
  }
  /deep/ .el-tabs__nav-wrap::after{
    width: 12.6%;
  }

  /deep/ input::-webkit-outer-spin-button, /deep/ input::-webkit-inner-spin-button{
     -webkit-appearance: none !important;
     appearance: none !important;
     margin: 0;
  }

  /deep/ input[type="number"]{
   -moz-appearance:textfield;
   }
</style>
